import { OptionType } from './Employee.types';

export const CURP_SEX_OPTIONS: OptionType[] = [
	{ id: 'HOMBRE', name: 'Hombre' },
	{ id: 'MUJER', name: 'Mujer' },
	{ id: 'NO_BINARIO', name: 'No binario' },
];

export const BIOLOGICAL_SEX_OPTIONS: OptionType[] = [
	{ id: 'HOMBRE', name: 'Hombre' },
	{ id: 'MUJER', name: 'Mujer' },
	{ id: 'INTERSEXUAL', name: 'Intersexual' },
];

export const GENDER_OPTIONS: OptionType[] = [
	{ id: 'NO_ESPECIFICADO', name: 'No especificado' },
	{ id: 'MASCULINO', name: 'Masculino' },
	{ id: 'FEMENINO', name: 'Femenino' },
	{ id: 'TRANSGENERO', name: 'Transgénero' },
	{ id: 'TRANSEXUAL', name: 'Transexual' },
	{ id: 'TRAVESTI', name: 'Travesti' },
	{ id: 'INTERSEXUAL', name: 'Intersexual' },
	{ id: 'OTRO', name: 'Otro' },
];

export const INHERITANCE_RIGHTS_EXCLUSIVE_IDS = [
	'NO ESPECIFICADO',
	'NINGUNA',
	'SE IGNORA',
];

export const NON_VALUE_RESIDENCE = [
	{
		id: '0',
		name: 'NO ESPECIFICADO',
	},
	{
		id: '88',
		name: 'NO APLICA',
	},
	{
		id: '99',
		name: 'SE IGNORA',
	},
	{
		id: '998',
		name: 'SE IGNORA',
	},
	{
		id: '9998',
		name: 'NO APLICA',
	},
	{
		id: '999',
		name: 'NO ESPECIFICADO',
	},
	{
		id: '9999',
		name: 'NO ESPECIFICADO',
	},
];

export const INHERITANCE_RIGHTS_OPTIONS: OptionType[] = [
	{ id: 'NO ESPECIFICADO', name: 'NO ESPECIFICADO' },
	{ id: 'NINGUNA', name: 'NINGUNA' },
	{ id: 'IMSS', name: 'IMSS' },
	{ id: 'ISSSTE', name: 'ISSSTE' },
	{ id: 'PEMEX', name: 'PEMEX' },
	{ id: 'SEDENA', name: 'SEDENA' },
	{ id: 'SEMAR', name: 'SEMAR' },
	{ id: 'OTRA', name: 'OTRA' },
	{ id: 'IMSS Bienestar', name: 'IMSS Bienestar' },
	{ id: 'ISSFAM', name: 'ISSFAM' },
	{ id: 'OPD IMSS BIENESTAR', name: 'OPD IMSS BIENESTAR' },
	{ id: 'SE IGNORA', name: 'SE IGNORA' },
];

export const MEXICO_CODE = '142';
